<script setup lang="ts">
import { refreshTokenIsValid, setAllCookies, tokenIsValid } from '@/services/utils';
import { CookiesName } from '@/api';
import { useCookies } from 'vue3-cookies';
import { useRouter } from 'vue-router';
import { getLeagueOfPredictorsAPIGateway } from '@/api/generated';
import type { TLoginApiResponse } from '@/types/users';

const { cookies } = useCookies();
const { push } = useRouter();
const { getApiV1UserProfile, postApiV1AuthRefresh } =
  getLeagueOfPredictorsAPIGateway();

if (tokenIsValid()) {
  await getApiV1UserProfile();
} else if (refreshTokenIsValid()) {
  const response = await postApiV1AuthRefresh({
    accessToken: cookies.get(CookiesName.token) ?? '',
    refreshToken: cookies.get(CookiesName.refreshToken) ?? '',
  });
  if (response) {
    setAllCookies(response as unknown as TLoginApiResponse);
  }
  await getApiV1UserProfile();
  await push({ name: 'base' });
}
</script>

<template>
  <slot />
</template>
